import React, {useEffect, useState} from "react";
import {Button} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {TICKET_SCOPES} from "constants/ticket";
import {TicketList} from "./TicketList";
import {useTicketOptions} from "./useTicketOptions";
import {CreateTicketModal} from "../create/CreateTicketModal";

// Kurye / Alt Firma detay sayfalarındaki "Talepler" sekmesi: sahibe ait talepler ve yeni talep
export const OwnerTicketsTab = ({category, ownerId, ownerName, isTabActive = true}) => {
    const {t} = useTranslation(["tickets"]);
    const {roleOptions, roleLabels} = useTicketOptions();
    const [activated, setActivated] = useState(isTabActive);
    const [createVisible, setCreateVisible] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        if (isTabActive) {
            setActivated(true);
        }
    }, [isTabActive]);

    if (!activated) {
        return null;
    }

    return (
        <div style={{padding: "16px 0"}}>
            <div style={{textAlign: "right", marginBottom: 16}}>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setCreateVisible(true)}
                >
                    {t("tab.create", {ns: "tickets"})}
                </Button>
            </div>
            <TicketList
                scope={TICKET_SCOPES.owner}
                category={category}
                ownerId={ownerId}
                ownerView
                roleOptions={roleOptions}
                roleLabels={roleLabels}
                refreshKey={refreshKey}
            />
            <CreateTicketModal
                visible={createVisible}
                category={category}
                ownerId={ownerId}
                ownerName={ownerName}
                showOwnerVisibility
                onCancel={() => setCreateVisible(false)}
                onSuccess={() => {
                    setCreateVisible(false);
                    setRefreshKey(previous => previous + 1);
                }}
            />
        </div>
    );
};
